import { render } from "./CreateVendorServiceModal.vue?vue&type=template&id=01adcd14"
import script from "./CreateVendorServiceModal.vue?vue&type=script&lang=js"
export * from "./CreateVendorServiceModal.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__